import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, Form, useResourceContext, useNotify, FunctionField, NumberField } from 'react-admin';
import {
  useListContext,
  useRedirect,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,

  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  BulkDeleteWithConfirmButton,
  Show,
  SimpleShowLayout,

  ReferenceField,
  TextField,
  ImageField,
  BooleanField,

  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  BooleanInput,
  NullableBooleanInput,

  Button,
  EditButton,
  ShowButton,
  SaveButton,
} from 'react-admin';
import { useForm, useFormContext } from 'react-hook-form';
import { Button as MButton, Box, useMediaQuery, Stack } from '@mui/material';
import { FirstImageField, PreviewImage, UpLoadFile } from './custom/UpLoadFile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import ClearAllIcon from '@mui/icons-material/ClearAll';
//import ResetOrderNum from './ProductCategory_ResetOrderNum';

{/* 
  import { ProductCategoryList, ProductCategoryCreate, ProductCategoryEdit, ProductCategoryShow } from './components/ProductCategory';

  <Resource name="CMSProductCategory" list={ProductCategoryList} create={ProductCategoryCreate} edit={ProductCategoryEdit} show={ProductCategoryShow} />
  <Resource name="CMSProductCategory" list={ListGuesser} create={EditGuesser} edit={EditGuesser} edit={ShowGuesser} /> 
*/}

const useStyles = makeStyles()((theme) => {
  return {
    imageField: {
      '& img.RaImageField-image': { width: 60 }
    },
  };
});


const useTxtData = {
  page: {
    tableName: 'ProductCategory',
  },
  table: {
    id: 'id',
    PC_ParentID: '级别',
    PC_Name: '分类名称',
    PC_PcImge: 'PC图标',
    PC_Order: 'PC_Order',
    PC_IsNav: '导航栏显示',
    PC_list: '首页列表显示',
    PC_WapImge: 'WAP图标',
    OrderNum: '排序',
    UpTime: '更新时间',
    A: 'A',
    B: 'B',
    C: 'C',
    D: '推荐排序编号(如果设置了，PC首页就按照设置的显示9个，否则显示列表排序的前9个)',
    E: '广告',
  }
};

//分页列表页面
export const ProductCategoryList = () => {
  const redirect = useRedirect();//奇怪问题：这句必须保留，去掉后下面Filters里的setFilters({}, displayedFilters);会失效
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  // 筛选器模块
  // const Filters = () => {
  //   return (
  //     <Filter>
  //       <TextInput label="ID" source="id" alwaysOn />
  //     </Filter>
  //   );
  // };
  const MobileFilters = [
    <TextInput label="关键词" source="Key" alwaysOn resettable />
  ];
  const Filters = (props: any) => {
    const { displayedFilters, filterValues, setFilters, hideFilter, refetch } = useListContext();
    if (isSmall) return null;
    if (props.context === "button") return null;
    const onSubmit = (values: any) => { if (Object.keys(values).length > 0) { setFilters(values, displayedFilters); } else { setFilters({}, displayedFilters); } };
    const resetFilter = () => { setFilters({}, displayedFilters); };
    return (
      <div>
        <Form onSubmit={onSubmit} defaultValues={filterValues}>
          <Stack direction={'row'} alignItems={'baseline'} spacing={1.5}>
            <TextInput label="关键词" source="Key" alwaysOn resettable />
            <MButton variant="contained" color="primary" type="submit" startIcon={<SearchIcon />}>搜索</MButton>
            <MButton variant="outlined" onClick={resetFilter} startIcon={<ClearAllIcon />}>重置</MButton>
          </Stack>
        </Form>
      </div>
    );
  };

  //批量操作模块
  const PostBulkActionButtons = () => {
    return (
      <Fragment>
        {/* <ResetOrderNum label="重置排序"  /> */}
        {/* <BulkDeleteWithConfirmButton confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" mutationMode='undoable' /> */}
      </Fragment>
    );
  };
  //行右侧功能按钮
  const RowAction = () => {
    return (
      <div style={{ textAlign: 'right' }}>
        <EditButton /><br />
        {/* <ShowButton /><br /> */}
        {/* <DeleteWithConfirmButton confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" /> */}
      </div>
    );
  }

  const { classes } = useStyles();
  return (
    <List
      title={useTxtData.page.tableName + '列表'}
      sort={{ field: 'id', order: 'DESC' }}
      // filters={<Filters />}
      exporter={false}
      sx={{ "& .MuiToolbar-root .MuiToolbar-root": { height: 0, minHeight: 0 } }}
      pagination={false}
    >
      <Datagrid
        // bulkActionButtons={<PostBulkActionButtons />}
        bulkActionButtons={false}
      >
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" sortable={false} />
        <FunctionField label='级别' render={({ PC_ParentID }: any) =>
          <>
            <Stack sx={{ minWidth: 50 }} >{PC_ParentID == 0 ? '顶级' : '------------'}</Stack>
          </>
        } />
        {/* <TextField label={useTxtData.table.PC_Name} source="PC_Name" /> */}
        <FunctionField label={useTxtData.table.PC_Name} render={({ PC_ParentID, PC_Name }: any) =>
          <>
            <Stack sx={{ minWidth: 100, pl: PC_ParentID == 0 ? 0 : 4 }}>{PC_Name}</Stack>
          </>
        } />
        <FunctionField label={useTxtData.table.PC_Name} render={({ C }: any) =>
          <a target='_blank' href={C}><FirstImageField sx={{ '& img': { height: 60 } }} label='广告图' source='E' subSource='src' /></a>
        } />

        <FirstImageField sx={{ '& img': { width: 20, height: 20 } }} label='PC图标' source='PC_PcImge' subSource='src' />
        <FirstImageField sx={{ '& img': { width: 20, height: 20 } }} label='Wap图标' source='PC_WapImge' subSource='src' />

        <FunctionField label={useTxtData.table.PC_IsNav} render={({ PC_IsNav }: any) =>
          <>{PC_IsNav == true ? <BooleanField source="PC_IsNav" /> : null}</>
        } />
        <FunctionField label={useTxtData.table.PC_list} render={({ PC_list }: any) =>
          <>{PC_list == true ? <BooleanField source="PC_list" /> : null}</>
        } />

        {/* <TextField label={useTxtData.table.OrderNum} source="OrderNum" /> */}
        <FunctionField label={useTxtData.table.OrderNum} render={({ PC_ParentID, OrderNum }: any) =>
          <>
            <Stack sx={{ minWidth: 50, pl: PC_ParentID == 0 ? 0 : 4 }}>{OrderNum}</Stack>
          </>
        } />

        <TextField label={useTxtData.table.UpTime} source="UpTime" sortable={false} />
        {/* <TextField label={useTxtData.table.A} source="A" />
        <TextField label={useTxtData.table.B} source="B" />
        <TextField label={useTxtData.table.C} source="C" />
        <TextField label={useTxtData.table.D} source="D" />
        <TextField label={useTxtData.table.E} source="E" /> */}
        <RowAction />
      </Datagrid>
    </List>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//SHOW页面
export const ProductCategoryShow = () => {
  const ShowActions = () => {
    const resource = useResourceContext();
    const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text">
          <ArrowBackIcon />
        </Button>
        <EditButton />
      </TopToolbar>
    );
  };

  const { classes } = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} actions={<ShowActions />}>
      <SimpleShowLayout>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.PC_ParentID} source="PC_ParentID" />
        <TextField label={useTxtData.table.PC_Name} source="PC_Name" />
        <TextField label={useTxtData.table.PC_PcImge} source="PC_PcImge" />
        <TextField label={useTxtData.table.PC_Order} source="PC_Order" />
        <TextField label={useTxtData.table.PC_IsNav} source="PC_IsNav" />
        <TextField label={useTxtData.table.PC_list} source="PC_list" />
        <TextField label={useTxtData.table.PC_WapImge} source="PC_WapImge" />
        <TextField label={useTxtData.table.OrderNum} source="OrderNum" />
        <TextField label={useTxtData.table.UpTime} source="UpTime" />
        <TextField label={useTxtData.table.A} source="A" />
        <TextField label={useTxtData.table.B} source="B" />
        <TextField label={useTxtData.table.C} source="C" />
        <TextField label={useTxtData.table.D} source="D" />
        <TextField label={useTxtData.table.E} source="E" />
      </SimpleShowLayout>
    </Show>
  );
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//编辑页面
export const ProductCategoryEdit = () => {
  const resource = useResourceContext();
  const redirect = useRedirect();

  const PostEditActions = () => {
    return (
      <TopToolbar >
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text">
          <ArrowBackIcon />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = () => {
    return (
      <Toolbar >
        <SaveButton />
      </Toolbar>
    );
  };
  return (
    <Edit redirect={`/${resource}`} title={'编辑' + useTxtData.page.tableName} actions={<PostEditActions />} mutationMode="pessimistic">
      <MyForm Edit={true} toolbar={<PostEditToolbar />} />
    </Edit>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//创建页面
export const ProductCategoryCreate = () => {
  const resource = useResourceContext();
  const redirect = useRedirect();
  const notify = useNotify();

  const PostCreateActions = () => {
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text" >
          <ArrowBackIcon />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = () => {
    const { reset, resetField, handleSubmit, setValue, getValues, } = useFormContext();
    return (
      <Toolbar>
        <SaveButton alwaysEnable label="保存&列表" />
        <SaveButton alwaysEnable type='button' label="保存&继续" variant="text" mutationOptions={{
          onSuccess: () => {
            notify('创建成功', { type: 'success' });
            reset();
          }
        }} />
      </Toolbar>
    );
  };

  return (
    <Create redirect={`/${resource}`} title={'新增' + useTxtData.page.tableName} actions={<PostCreateActions />}>
      <MyForm Create={true} toolbar={<PostCreateToolbar />} />
    </Create>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
//Create和Edit公用表单
const MyForm = (props: any) => {
  let { Edit, Create } = props;
  return (
    <SimpleForm {...props} >
      {/* <TextInput source="Name" /> */}
      {/* <NumberInput source="OrderNum" /> */}
      {/* <TextInput label={useTxtData.table.id} source="id" validate={[required()]} /> */}

      {/* <TextInput label={useTxtData.table.PC_ParentID} source="PC_ParentID" validate={[required()]} /> */}
      <ReferenceInput source="PC_ParentID" reference="Admin/CMSProductCategory" filter={{ onlyTop: true }}>
        <SelectInput disabled={Edit} label={useTxtData.table.PC_ParentID} optionText={({ PC_Name }: any) => `${PC_Name}`} />
      </ReferenceInput>


      <TextInput label={useTxtData.table.PC_Name} source="PC_Name" validate={[required()]} />

      {/* <TextInput label={useTxtData.table.PC_PcImge} source="PC_PcImge" validate={[required()]} /> */}
      <UpLoadFile label={useTxtData.table.PC_PcImge} source="PC_PcImge" validate={[]} />
      {/* <TextInput label={useTxtData.table.PC_WapImge} source="PC_WapImge" validate={[required()]} /> */}
      <UpLoadFile label={useTxtData.table.PC_WapImge} source="PC_WapImge" validate={[]} />

      {/* <TextInput label={useTxtData.table.PC_Order} source="PC_Order" validate={[required()]} /> */}

      <BooleanInput label={useTxtData.table.PC_IsNav} source="PC_IsNav" validate={[required()]} defaultValue={false} />
      <BooleanInput label={useTxtData.table.PC_list} source="PC_list" validate={[required()]} defaultValue={false} />

      <UpLoadFile label={'广告图'} source="E" validate={[]} />
      <TextInput label={'广告图跳转Url'} source="C" validate={[]} fullWidth />

      <TextInput label={useTxtData.table.D} source="D" validate={[]} sx={{ minWidth: 800 }} />
      <NumberInput label={useTxtData.table.OrderNum} source="OrderNum" validate={[required()]} defaultValue={0} />
      {/* <TextInput label={useTxtData.table.UpTime} source="UpTime" validate={[required()]} /> */}
      {/* <TextInput label={useTxtData.table.A} source="A" validate={[required()]} />
      <TextInput label={useTxtData.table.B} source="B" validate={[required()]} />
      <TextInput label={useTxtData.table.C} source="C" validate={[required()]} />
      <TextInput label={useTxtData.table.D} source="D" validate={[required()]} />
      <TextInput label={useTxtData.table.E} source="E" validate={[required()]} /> */}
    </SimpleForm>
  );
}